import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CompanyTypeClient, CompanyTypeView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class CompanyTypeService {
    constructor(private readonly client: CompanyTypeClient) {}

    async getAll(): Promise<CompanyTypeView[]> {
        return await lastValueFrom(this.client.companyTypeGetAll());
    }
}
